export default "__VITE_ASSET__53faab4a__"